import { Icon } from '$ui/Flo/Icon';
import * as React from 'react';
import { ChannelConfig } from '$state/types';
import { Hue } from '$ui/Flo/types';
import styled, { css } from 'styled-components';
import { mix } from '$ui/Flo/util';
import { useHistory } from 'react-router-dom';

interface TemplateBarProps {
    channel: ChannelConfig;
    onClick: () => void;
    disabled?: boolean;
}

export const TemplateBar = (props: TemplateBarProps) => {
    const { channel,onClick, disabled = false } = props;

    const isSelected = useHistory().location.pathname.includes(channel.channel);

    return (
        <Container
    onClick={onClick}
    $disabled={disabled}
    $selected={isSelected}
    role="tab"
    aria-label={`${channel.label} Tab`}
    title={`${channel.label} Tab`}
    data-qa={'tab-' + channel.channel}
        >
            <Icon
                size={2}
                icon={channel.icon}
                hue={getHue(isSelected)}
                opacity={getOpacity(disabled)}
                clickable={!disabled}
            />
            {channel.label}
        </Container>
    );
};

interface ContainerProps {
    $selected: boolean;
    $disabled: boolean;
}

const Container = styled.div<ContainerProps>`
    ${mix.padding({ padding: [1, 1.5] })};
    ${mix.type({ level: 'small' })};
    font-family: Roboto, serif;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    gap: ${mix.unit({ size: 1 })};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    color: ${({ $selected, $disabled }) => getColor($selected, $disabled)};

    ${({ $selected }) =>
    $selected &&
    css`
            border-bottom: 1px solid var(--primary-500);
        `}
`;


const getColor = (selected: boolean, disabled: boolean) => {
    if (disabled) {

        return 'var(--gray-400)';
    }

    if (selected) {

        return 'var(--primary-500)';
    }

    return 'var(--gray-600)';
};

const getOpacity = (disabled: boolean): number => (disabled ? 0.5 : 1);
//
const getHue = (selected: boolean): Hue => (selected ? 'primary' : 'type');
